export default "__VITE_ASSET__B0ilg2MQ__";